import { BankResetItems } from "web/types/Banks";
import { IPaymentSettingsItem } from "web/types/Payment";

import selectBankCountsForPaymentSortContext from "./selectBankCountsForPaymentSortContext";
import sortRules from "./sortRules";
import { getResetDateTimeByBankId } from "./sortRules/sortRuleReset";
import { ProductToSeparateWithPaymentSettings } from "./types";

type BankCountsForPaymentSortContext = ReturnType<
  typeof selectBankCountsForPaymentSortContext
>;

interface ISortPaymentSettingsParams {
  paymentSettings: IPaymentSettingsItem[];
  sourceArray: ProductToSeparateWithPaymentSettings[];
  current: ProductToSeparateWithPaymentSettings;
  bankCountsForPaymentSortContext: BankCountsForPaymentSortContext;
  bankResets: BankResetItems;
}

const sortPaymentSettings = ({
  paymentSettings,
  sourceArray,
  current,
  bankCountsForPaymentSortContext,
  bankResets,
}: ISortPaymentSettingsParams) => {
  const resetDateTimeByBankId = getResetDateTimeByBankId(bankResets);

  const { productCountByBankId, banksSub10Products } =
    bankCountsForPaymentSortContext;

  return paymentSettings.sort((firstPayment, secondPayment) => {
    const context = {
      products: sourceArray,
      product: current,
      productCountByBankId,
      banksSub10Products,
      resetDateTimeByBankId,
    };

    return sortRules.reduce((acc, rule) => {
      if (acc !== 0) {
        return acc;
      }

      return rule(firstPayment, secondPayment, context);
    }, 0);
  });
};

export default sortPaymentSettings;
